module.exports = __webpack_public_path__ + "img/link-icon-van.3c0d98d9.svg";